module.exports = __webpack_public_path__ + "static/media/Forest Maiden.01e8a6e3.jpg";